const twigsConfig = {
    theme: {
      extends: {
        colors: {
          primary: "#2E666D",
          secondary: "#363A43",
        },
        fonts: {
          body: "'DM Sans', 'Helvetica', 'Arial', sans-serif",
          heading: "'DM Sans', 'Helvetica', 'Arial', sans-serif"
        }
      }
    }
  };

export default twigsConfig;